<template>
    <div v-if="this.isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <v-container>
            <v-form ref="rewardForm">
                <v-row style="margin-top: 20px;">
                    <v-col cols="5" sm="5" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('columns.recorddate')" type="date" ref="recdate"
                            :rules="[rules.required]" v-model="formData.recdate" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-autocomplete
                            outlined :label="this.$t('columns.recordtype')"
                            type="text" :items="movementList"
                            hide-selected v-model="formData.movtypeid"
                            :rules="[rules.required]" dense
                            @change="changeMovementHandler(formData.movtypeid)"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field
                            dense :label="this.$t('columns.code')" outlined
                            readonly background-color="#ffeab2"
                            v-model="movementCode"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-autocomplete
                            outlined :label="this.$t('columns.reason')"
                            type="text" :items="reasonList" :rules="[rules.required]"
                            hide-selected v-model="formData.reasonid"
                            @change="changeReasonHandler(formData.reasonid)" dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="1" sm="1" class="pb-n4 mt-n8">
                        <v-dialog
                            v-model="reasonDialog"
                            max-width="500px"
                            persistent
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn dense v-on="on">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <app-genericform
                                    v-bind:parentData="{
                                        tabItems: reasonItems,
                                        formTitle: `${this.$t('columns.reason')}`, 
                                        formId: 'reason',
                                    }"
                                    v-on:input="itemData = $event"
                                    v-on:saveReason="saveReasonHandler"
                                    v-on:deleteReason="deleteReasonHandler($event)"
                                />
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="warning" text
                                        @click="reasonDialog = false"
                                    >
                                        {{$t('button.close')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-text-field
                            dense :label="this.$t('columns.code')"
                            outlined readonly
                            background-color="#ffeab2" v-model="reasonCode"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <app-formbuttons 
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler" 
                />
            </v-form>
        </v-container>
        <div>
            <app-success
                v-if="isSuccessDialogOpen"
                :key="successkey"
                :parentObject="successDialogData"
                
            />
        </div>
    </div>
</template>

<script>
//import moment from 'moment';
import SuccessDialog from "../../../components/common/SuccessDialog";
import GenericForm from "../../generic/GridForm";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-success": SuccessDialog,
        "app-genericform": GenericForm,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                rewardrecordid: this.parentObject.rewardrecordid,

                id: this.parentObject?.data?.id || null,
                stamp: this.parentObject?.data?.stamp || 0,
                updatedby: this.$store.getters.userId || null,

                recdate: this.parentObject?.data?.recdate || null,
                movtypeid: this.parentObject?.data?.movtypeid || null,
                reasonid: this.parentObject?.data?.reasonid || null,
            },

            defaultForm: {
                rewardrecordid: this.parentObject.rewardrecordid,

                id: this.parentObject?.data?.id || null,
                stamp: this.parentObject?.data?.stamp || 0,
                updatedby: this.$store.getters.userId || null,

                recdate: this.parentObject?.data?.recdate || null,
                movtypeid: this.parentObject?.data?.movtypeid || null,
                reasonid: this.parentObject?.data?.reasonid || null,
            },

            isEdit: this.parentObject.isEdit,
            errMsg: '',
            isErr: false,
            isLoading: true,
            isSuccessDialogOpen: false,
            successDialogData: {
                isSuccess: false,
                messageSuccess: "",
            },
            successkey: 0,//this is use to force open and close the confirm dialog
            

            reasonDialog: false,
            reasons: [],
            reasonList: [],
            reasonItems: [],
            movements: [],
            movementList: [],

            movementCode: null,
            reasonCode: null,
        }
    },

    methods: {        
        async saveHandler() {
            const isValid = await this.$refs.rewardForm.validate();
            if (!isValid) {
                 // Form validation failed
                this.isErr = true;
                this.errMsg = 'Please fill all required fields correctly.';
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }
    
            if (this.isEdit) { // Edit/update
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    console.error("❌ No permission to edit");
                    return false;
                }

                const res = await this.$store.dispatch('put', {
                    url: "/pmrewardsalarypostinginstruc/" + this.formData.rewardrecordid,
                    payload: this.formData
                });

                if (res.data.error) {
                    this.isErr = true;
                    this.errMsg = Array.isArray(res.data.error)
                        ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                        : res.data.error;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                } else {
                    this.defaultForm={... this.formData};//set as new default
                    this.isSuccessDialogOpen= false;
                    this.successkey++;
                    this.successDialogData.isSuccess = true;
                    this.successDialogData.messageSuccess = this.$t('pmrewardrecord.salarypostinginstrucupdate');
                    this.isSuccessDialogOpen = true;
                }
            }
            else{//create
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    console.error("❌ No permission to add");
                    return false;
                }

                const res = await this.$store.dispatch('post', {
                    url: "/pmrewardsalarypostinginstruc/create",
                    payload: this.formData
                });

                if (res.data.error) {
                    this.isErr = true;
                    this.errMsg = Array.isArray(res.data.error)
                        ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                        : res.data.error;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                } else {
                    this.defaultForm={... this.formData};//set as new default
                    this.isEdit= true; //set to edit mode now
                    this.isSuccessDialogOpen= false;
                    this.successkey++;
                    this.successDialogData.isSuccess = true;
                    this.successDialogData.messageSuccess = this.$t('pmrewardrecord.salarypostinginstruccreate');
                    this.isSuccessDialogOpen = true;
                }
            }
                
        },

        async cancelHandler() {
            this.formData = { ...this.defaultForm };//reset to default
            await this.loadMovementTypeListHandler();
            await this.loadReasonListHandler();
        },

        async loadMovementTypeListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/movtype/all" });
                this.movements = res.data.rec;
                this.movementList = []; // Clear the list before pushing new items

                // this.movementList.push({
                //     text: "Select Service Type",
                //     value: 0,
                // });

                for (let i = 0; i < res.data.rec.length; i++) {
                    this.movementList.push({
                        text: res.data.rec[i].movdesc,
                        value: res.data.rec[i].id,
                    });
                }

                if (this.formData.movtypeid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeMovementHandler(this.formData.movtypeid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeMovementHandler(id) {
            if (id == 0) {
                this.movementCode = "";
            } else {
                let item = this.movements.find((item) => item.id === id);

                this.movementCode = item.movcode;
            }
        },

        async loadReasonListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/reason/all" });
                this.reasons = res.data.rec;
                this.reasonList = []; // Clear the list before pushing new items
                this.reasonItems = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                    this.reasonList.push({
                        text: res.data.rec[i].reasondesc,
                        value: res.data.rec[i].id,
                    });

                    this.reasonItems.push({
                        id: res.data.rec[i].id,
                        code: res.data.rec[i].reasoncode,
                        desc: res.data.rec[i].reasondesc,
                        stamp: res.data.rec[i].stamp,
                    });
                }

                if (this.formData.reasonid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeReasonHandler(this.formData.reasonid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeReasonHandler(id) {
            let item = this.reasons.find((item) => item.id === id);
            this.reasonCode = item.reasoncode;
        },

        saveReasonHandler() {
            let vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {url:
                            "/reason/" +
                            this.itemData.itemid,
                        payload: {
                            userid: this.updatedby,
                            reasoncode: vm.itemData.itemcode,
                            reasondesc: vm.itemData.itemdesc,
                            stamp: vm.itemData.itemstamp,
                        }}
                    )
                    .then((res) => {
                        if (res.data.status == 200) {
                            // reset all arrays
                            vm.reasons = [];
                            vm.reasonList = [];
                            vm.reasonItems = [];

                            vm.loadReasonListHandler();
                        } else {
                            vm.isErr = true;
                            vm.errMsg = res.data.error;
                            vm.$emit("error", {
                                isErr: vm.isErr,
                                errMsg: vm.errMsg,
                            });
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err;
                        vm.$emit("error", {
                            isErr: vm.isErr,
                            errMsg: vm.errMsg,
                        });
                    });
            } else {
                this.$store.dispatch('post', {url: "/reason/create", payload: {
                        reasoncode: vm.itemData.itemcode,
                        reasondesc: vm.itemData.itemdesc,
                        userid: this.updatedby,
                    }})
                    .then((res) => {
                        if (res.data.status == 201) {
                            // reset all arrays
                            vm.reasons = [];
                            vm.reasonList = [];
                            vm.reasonItems = [];

                            vm.loadReasonListHandler();
                        } else {
                            vm.isErr = true;
                            vm.errMsg = res.data.error;
                            vm.$emit("error", {
                                isErr: vm.isErr,
                                errMsg: vm.errMsg,
                            });
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err;
                        vm.$emit("error", {
                            isErr: vm.isErr,
                            errMsg: vm.errMsg,
                        });
                    });
            }
        },

        deleteReasonHandler($event) {
            let vm = this;

            if (confirm("Remove " + $event.desc + "?")) {
                this.$store.dispatch('delete', {url:
                            "/reason/" +
                            $event.id +
                            "/" +
                            this.$store.getters.userId
                    })
                    .then((res) => {
                        if (res.data.status == 200) {
                            // reset all arrays
                            vm.reasons = [];
                            vm.reasonList = [];
                            vm.reasonItems = [];

                            vm.loadReasonListHandler();
                        } else {
                            vm.isErr = true;
                            vm.errMsg = res.data.error;
                            vm.$emit("error", {
                                isErr: vm.isErr,
                                errMsg: vm.errMsg,
                            });
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err;
                        vm.$emit("error", {
                            isErr: vm.isErr,
                            errMsg: vm.errMsg,
                        });
                    });
            }
        },
        
    },
    async mounted() {
        try {
            await this.loadMovementTypeListHandler();
            await this.loadReasonListHandler();
            this.isLoading = false;
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }

}
</script>
